import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { StudioTabsInfo } from '@/modules/Studios/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioTabs',
  props: {
    tabs: null,
    currentTab: null
  },
  emits: ["update:currentTab"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:currentTab', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tabs: StudioTabsInfo[]
  currentTab: number
};





const route = useRoute()
const router = useRouter()
const isExpansionPanelOpen = ref(false)

const currentTabItem = computed(() => props.tabs[props.currentTab])

const tabModel = computed({
  get: () => props.currentTab,
  set: (value) => {
    emit('update:currentTab', value)
  },
})

const setCurrentTab = (tabItem: StudioTabsInfo) => {
  if (route.query.tab === tabItem.name) {
    isExpansionPanelOpen.value = false
    return
  }
  router.push({
    name: route.name as string,
    params: { id: route.params.id },
    query: { tab: tabItem.name },
    hash: '#studio-tabs',
  })
  tabModel.value = tabItem.id
  isExpansionPanelOpen.value = false
}

return { __sfc: true,props, emit, route, router, isExpansionPanelOpen, currentTabItem, tabModel, setCurrentTab }
}

})